/**
 * Creates batches from an array of objects.
 */
export const createBatches = <T>(objects: T[], batchSize = 100): T[][] => {
  const batches: T[][] = [];

  for (let i = 0; i < objects.length; i += batchSize) {
    const batch = objects.slice(i, i + batchSize);
    batches.push(batch);
  }

  return batches;
};
